// Module
var code = "Anywhere, afterwards..... ";
// Exports
module.exports = code;